// Shared date helpers for form validation.

// True only if a YYYY-MM-DD string is a real calendar date.
// Rejects impossible dates like 2026-09-31 or 2026-02-30 that some browsers /
// locales let through a <input type="date">. Empty string is treated as valid
// (i.e. "not entered yet"), so callers decide whether a value is required.
export const isRealDate = (str) => {
  if (!str) return true;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
  if (!m) return false;
  const [, y, mo, d] = m.map(Number);
  const dt = new Date(str + 'T00:00:00');
  return dt.getFullYear() === y && dt.getMonth() + 1 === mo && dt.getDate() === d;
};

// Whole days between two YYYY-MM-DD strings (to − from); '' if either is missing/invalid.
export const diffDays = (from, to) => {
  if (!from || !to) return '';
  const a = new Date(from), b = new Date(to);
  if (isNaN(a) || isNaN(b)) return '';
  return Math.round((b - a) / 86400000);
};
